import { IAlarmStatus } from "@framework/provider-asu";

export const getMaxAlarmsStatusPointsOrVisualControl = (
  Points: IAlarmStatus[],
  considerVisualControlStatus: boolean,
): number => {
  const point = Points[0];

  if (!point) {
    return 255;
  }

  const status =
    point.PointStatus || point.AlarmStatus || (considerVisualControlStatus && point.VisualControlAlarmStatus) || 0;

  if (status !== 0) {
    return status;
  }

  const hasDefinedStatus =
    point.PointStatus === 0 ||
    point.AlarmStatus === 0 ||
    (considerVisualControlStatus && point.VisualControlAlarmStatus === 0);

  return hasDefinedStatus ? 0 : 255;
};
